import { render, staticRenderFns } from "./Bookkeeping.vue?vue&type=template&id=07f7bcea"
import script from "./Bookkeeping.vue?vue&type=script&lang=js"
export * from "./Bookkeeping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07f7bcea')) {
      api.createRecord('07f7bcea', component.options)
    } else {
      api.reload('07f7bcea', component.options)
    }
    module.hot.accept("./Bookkeeping.vue?vue&type=template&id=07f7bcea", function () {
      api.rerender('07f7bcea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Bookkeeping.vue"
export default component.exports